import * as React from 'react';

import {useGetSessionUser} from '../core/use-get-session-user';
import {CUE_CARD_COLLECTION} from '../glossary/consts/cue-card-collection';
import {CueCardStack} from '../glossary/layout/cue-card-stack';

type Props = {
    glossaryKey?: string | null;
    noBookmark?: boolean;
};

export function SettingsSidebar(props: Props) {
    const glossaryKey = props.glossaryKey || window.location.pathname;

    const {user} = useGetSessionUser();

    if (!glossaryKey || !CUE_CARD_COLLECTION[glossaryKey]) {
        return null;
    }

    const settingsCueCards = CUE_CARD_COLLECTION[glossaryKey].cards
        .filter((card) => card.location === 'settings-sidebar')
        .filter((card) => !card.adminOnly || (user && user.isAdministrator));

    return <CueCardStack cards={settingsCueCards} noBookmark={props.noBookmark} />;
}
